(function () {
  const THRESHOLD = 25000; // AED 250 in fils

  function renderBar(el, total) {
    const remaining = THRESHOLD - total;
    if (total >= THRESHOLD) {
      el.innerHTML = `
        <p class="fsb__msg fsb__msg--success">🎉 You have FREE delivery!</p>
        <div class="fsb__track"><div class="fsb__fill" style="width:100%"></div></div>`;
    } else {
      let pct = Math.round((total / THRESHOLD) * 100);
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      el.innerHTML = `
        <p class="fsb__msg">Add <strong>AED ${Math.round(remaining / 100)}</strong> more for FREE delivery</p>
        <div class="fsb__track"><div class="fsb__fill" style="width:${pct}%"></div></div>`;
    }
  }

  function refresh() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.fsb').forEach(el => renderBar(el, cart.total_price));
      })
      .catch(() => {});
  }

  // Refresh whenever Shopify signals a cart change
  ['cart:updated', 'cart:refresh', 'cart:change', 'on:line-item:change', 'on:quick-order-list:update'].forEach(evt => {
    document.addEventListener(evt, refresh);
  });

  // Fallback: observe the cart drawer opening
  const drawer = document.querySelector('cart-drawer, .cart-drawer, #cart-drawer');
  if (drawer) {
    new MutationObserver(refresh).observe(drawer, {
      attributes: true, childList: true, subtree: true
    });
  }

  // Initial render on page load
  document.addEventListener('DOMContentLoaded', refresh);
})();